import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-delegationofauthority',
  imports: [RouterOutlet],
  templateUrl: './delegationofauthority.component.html',
  styleUrls: ['./delegationofauthority.component.css'],
})
export class DelegationofauthorityComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}
  
}
